import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

interface IMYoutubeSlider {
  autoPlay?: boolean;
  animation?: "fade" | "slide";
  indicators?: boolean;
  duration?: number;
  navButtonsAlwaysVisible?: boolean;
  navButtonsAlwaysInvisible?: boolean;
  fullHeightHover?: boolean;
  cycleNavigation?: boolean;
  swipe?: boolean;
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  secondExaple: {
    maxWidth: "320px",
    width: 320,
    display: "block",
  },
  project: {
    maxWidth: "100%",
    position: "relative",
    height: "300px",
    overflow: "hidden",
    // padding: "20px",
  },
  checkButton: {
    marginTop: "40px",
    color: "white",
    fontSize: 16,
    border: "3px solid white",
    textTransform: "capitalize",
  },
}));

const MobileYoutubeSlider1 = (props: IMYoutubeSlider) => {
  const classes = useStyles();

  return (
    <div style={{ color: "#494949" }}>
      <Carousel
        autoPlay={false}
        animation="slide"
        indicators={true}
        duration={500}
        navButtonsAlwaysVisible={true}
        navButtonsAlwaysInvisible={false}
        cycleNavigation={true}
        fullHeightHover={false}
        swipe={true}
        className={classes.secondExaple}
        navButtonsProps={{
          style: { backgroundColor: "white" },
        }}
        navButtonsWrapperProps={{
          style: { top: 300, height: 40 },
        }}
        indicatorIconButtonProps={{
          style: {
            top: -5,
            // color: "#EB5FE5",
          },
        }}
        // activeIndicatorIconButtonProps={{
        //   style: {
        //     backgroundColor: "red",
        //   },
        // }}
      >
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Carousel>
    </div>
  );
};

type Item = {
  name?: string;
  description?: string;
  color?: string;
  href?: any;
  content?: any;
};

interface ProjectProps {
  item: Item;
}

function Project({ item }: ProjectProps) {
  const classes = useStyles();

  return (
    <Paper
      className={classes.project}
      style={{
        // backgroundColor: item.color,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
      }}
      elevation={10}
    >
      {/* <Typography variant="h5">{item.name}</Typography>
      <br />
      <Typography>{item.description}</Typography> */}
      {item.href}
      {item.content}
      {/* <Button
        className={classes.checkButton}
        component="a"
        href={item.href}
        target="_blank"
        rel="noreferrer"
      >
        Check it out!
      </Button> */}
    </Paper>
  );
}

const items: Item[] = [
  {
    name: "",
    description: "",
    color: "pink",
    href: (
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/ES1RRDkqDvk"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    ),
    content: "",
  },
  {
    name: "",
    description: "",
    color: "orange",
    href: (
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/7hLhzwS5op4"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    ),
    content: "",
  },
];

export default MobileYoutubeSlider1;
